<div class="modal-header">
    <h4 class="mb-0" style="width: 100%">{{ title }}</h4>
    <div class="d-flex text-right" style="width: 100%">
        <div class="activity_title_wrapper d-flex align-items-center justify-content-end w-100">
            <ng-container>
                <span class="activity_title">{{ 'IDMS.REPORTS.REPORT_NAME' | transloco }}</span>
                <span class="section-data">{{ reportName }}</span>
            </ng-container>
        </div>
    </div>
    <a class="" href="javascript:void()" ngbAutofocus (click)="closeClick()"><i class="flaticon2-cross"></i></a>
</div>
<div class="modal-body reportModal_body" [formGroup]="scheduleForm">
    <div class="control-wrapper">
        <div class="row">
            <div class="col-md-2">
                <div class="label-wrap">
                    <mat-label class="font-style">* {{ 'IDMS.REPORTS.NAME' | transloco }}:</mat-label>
                </div>
            </div>
            <div class="col-md-10">
                <input
                    type="text"
                    class="input-form-class"
                    matInput
                    name="Name"
                    placeholder="{{ 'IDMS.REPORTS.NAME' | transloco }}"
                    formControlName="Name"
                    [ngClass]="checkControl('Name') ? '' : 'highLight'"
                />
                <ng-container *ngIf="!checkControl('Name')">
                    <div>
                        <p class="error-message" *ngIf="!checkControl('Name')">{{ 'IDMS.REPORTS.PLEASE_FILL_REQUIRED_FIELDS' | transloco }}</p>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <div class="label-wrap">
                    <mat-label class="font-style">{{ 'IDMS.REPORTS.DESCRIPTION' | transloco }}:</mat-label>
                </div>
            </div>
            <div class="col-md-10">
                <input
                    type="text"
                    class="input-form-class"
                    matInput
                    name="Description"
                    placeholder="{{ 'IDMS.REPORTS.DESCRIPTION' | transloco }}"
                    formControlName="Description"
                />
            </div>
        </div>
    </div>
    <div class="row align-items-center">
        <div class="col-sm-12">
            <mat-label class="font-style label_border schedule_heading">{{ 'IDMS.REPORTS.RECURRENCE_PATTERN' | transloco }}</mat-label>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-sm-2">
            <div class="radio_select">
                <mat-radio-group
                    aria-label="Select an option"
                    class="example-radio-group radio-wrap"
                    formControlName="radio_btn_value"
                    (selectionChange)="changeUnit($event)"
                    name="radio_btn_value"
                >
                    <mat-radio-button class="example-radio-button radio-wrapper" value="1">{{ 'IDMS.REPORTS.HOURLY' | transloco }}</mat-radio-button>
                    <mat-radio-button class="example-radio-button radio-wrapper" value="2">{{ 'IDMS.REPORTS.DAILY' | transloco }}</mat-radio-button>
                    <mat-radio-button class="example-radio-button radio-wrapper" value="3">{{ 'IDMS.REPORTS.WEEKLY' | transloco }}</mat-radio-button>
                    <mat-radio-button class="example-radio-button radio-wrapper" value="4">{{ 'IDMS.REPORTS.MONTHLY' | transloco }}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="col-sm-10">
            <div class="radio_select border_left" *ngIf="radio_btn_value == '1'">
                <mat-radio-group class="example-radio-group radio-wrap" aria-label="Select an option" class="example-radio-button radio-wrapper">
                    * {{ 'IDMS.REPORTS.RECUR_EVERY' | transloco }} <input type="number" formControlName="hours" class="day_number_without-background" />
                    {{ 'IDMS.REPORTS.HOURS' | transloco }}
                    <ng-container *ngIf="!checkControl('hours') && radio_btn_value == '1'">
                        <div>
                            <p class="error-message" *ngIf="!checkControl('hours') && radio_btn_value == '1'">
                                {{ 'IDMS.REPORTS.PLEASE_INPUT_HOURS' | transloco }}
                            </p>
                        </div>
                    </ng-container>
                </mat-radio-group>
            </div>
            <div class="radio_select border_left" *ngIf="radio_btn_value == '2'">
                <mat-radio-group aria-label="Select an option" formControlName="radio_btn_daily">
                    <mat-radio-button class="example-radio-button radio-wrapper" value="a" (change)="onRadioButtonChange($event)"
                        >{{ 'IDMS.REPORTS.ON_THE_FOLLOWING_DAYS' | transloco }}
                    </mat-radio-button>
                    <section class="example-section1">
                        <mat-checkbox
                            *ngFor="let x of DayListCopy"
                            [value]="x.value"
                            class="example-margin mr-2 checkbox-wrap"
                            [checked]="x.checked"
                            (change)="DaycheckDaily($event, x)"
                            [disabled]="radio_btn_daily != 'a'"
                            >{{ x.name }}</mat-checkbox
                        >
                    </section>

                    <ng-container *ngIf="!checkControl('days') && radio_btn_daily == 'a'">
                        <div>
                            <p class="error-message" *ngIf="!checkControl('days')">
                                {{ 'IDMS.REPORTS.PLEASE_SELECT_ATLEAST_ONE_CHECKBOX' | transloco }}
                            </p>
                        </div>
                    </ng-container>
                    <mat-radio-button class="example-radio-button radio-wrapper" value="b" (change)="onRadioButtonChange($event)"
                        >{{ 'IDMS.REPORTS.EVERY_WEEKDAY' | transloco }}
                    </mat-radio-button>
                    <mat-radio-button class="example-radio-button radio-wrapper" (change)="onRadioButtonChange($event)" value="c"
                        >{{ 'IDMS.REPORTS.REPEAT_AFTER' | transloco }}
                        <input type="number" class="day_number" formControlName="day_number" [disabled]="radio_btn_daily != 'c'" />
                        {{ 'IDMS.REPORTS.NUMBER_OF_DAYS' | transloco }}
                        <ng-container *ngIf="(day_number?.errors?.max || day_number?.errors?.min) && radio_btn_daily == 'c'">
                            <div>
                                <p class="error-message" *ngIf="day_number?.errors?.max || day_number?.errors?.min">
                                    {{ 'IDMS.REPORTS.DAYS_MUST_BE_WITHIN_1_TO_29' | transloco }}
                                </p>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!checkControl('day_number') && radio_btn_daily == 'c'">
                            <div>
                                <p class="error-message" *ngIf="!checkControl('day_number')">
                                    {{ 'IDMS.REPORTS.PLEASE_INPUT_DAYS' | transloco }}
                                </p>
                            </div>
                        </ng-container>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="radio_select border_left" *ngIf="radio_btn_value == '3'">
                <mat-radio-group aria-label="Select an option" formControlName="radio_btn_weekly" class="example-radio-group radio-wrap">
                    <mat-radio-button value="a" class="example-radio-button radio-wrapper"
                        >* {{ 'IDMS.REPORTS.PLEASE_INPUT_HOURS' | transloco }}Recure every
                        <input type="number" class="day_number" formControlName="week_number" /> {{ 'IDMS.REPORTS.WEEKS_ON' | transloco }}
                        <ng-container *ngIf="(week_number?.errors?.max || week_number?.errors?.min) && radio_btn_value == '3'">
                            <div>
                                <p class="error-message" *ngIf="week_number?.errors?.max || week_number?.errors?.min">
                                    {{ 'IDMS.REPORTS.WEEKS_MUST_BE_WITHIN_1_TO_52' | transloco }}
                                </p>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!checkControl('week_number') && radio_btn_value == '3'">
                            <div>
                                <p class="error-message" *ngIf="!checkControl('week_number')">
                                    {{ 'IDMS.REPORTS.PLEASE_INPUT_WEEKS' | transloco }}
                                </p>
                            </div>
                        </ng-container>
                    </mat-radio-button>

                    <section class="example-section1">
                        <mat-checkbox
                            *ngFor="let x of DayList"
                            [value]="x.value"
                            class="example-margin mr-2 checkbox-wrap"
                            [checked]="x.checked"
                            (change)="WeekDaycheckDaily($event, x)"
                            >{{ x.name }}</mat-checkbox
                        >
                    </section>

                    <ng-container *ngIf="!checkControl('Weekdays') && radio_btn_value == '3'">
                        <div>
                            <p class="error-message" *ngIf="!checkControl('Weekdays')">
                                {{ 'IDMS.REPORTS.PLEASE_SELECT_ATLEAST_ONE_CHECKBOX' | transloco }}
                            </p>
                        </div>
                    </ng-container>
                </mat-radio-group>
            </div>
            <div class="radio_select border_left" *ngIf="radio_btn_value == '4'">
                <mat-radio-group aria-label="Select an option" formControlName="radio_btn_monthly" class="example-radio-group radio-wrap">
                    <label style="margin-bottom: 6px">{{ 'IDMS.REPORTS.ON_THE_MONTHS_OF' | transloco }}</label>
                    <section class="example-section1">
                        <mat-checkbox
                            *ngFor="let x of MonthList"
                            [value]="x.value"
                            class="example-margin mr-2 checkbox-wrap"
                            [checked]="x.checked"
                            (change)="MonthListcheck($event, x)"
                            >{{ x.name }}</mat-checkbox
                        >
                    </section>

                    <ng-container *ngIf="!checkControl('MonthList') && radio_btn_value == '4'">
                        <div>
                            <p class="error-message" *ngIf="!checkControl('MonthList')">
                                {{ 'IDMS.REPORTS.PLEASE_SELECT_ATLEAST_ONE_CHECKBOX' | transloco }}
                            </p>
                        </div>
                    </ng-container>
                    <mat-radio-button value="a" class="example-radio-button radio-wrapper"
                        >{{ 'IDMS.REPORTS.ON_THE' | transloco }}
                        <select formControlName="weekofthemonth" id="number" class="mr-2">
                            <option value="1">{{ 'IDMS.REPORTS.FIRST' | transloco }}</option>
                            <option value="2">{{ 'IDMS.REPORTS.SECOND' | transloco }}</option>
                            <option value="3">{{ 'IDMS.REPORTS.THIRD' | transloco }}</option>
                            <option value="4">{{ 'IDMS.REPORTS.FOURTH' | transloco }}</option>
                            <option value="5">{{ 'IDMS.REPORTS.FIFTH' | transloco }}</option>
                        </select>
                        {{ 'IDMS.REPORTS.WEEK_OF_THE_MONTHS_DURING_THE_FOLLOWING_DAYS' | transloco }}
                    </mat-radio-button>
                    <section class="example-section1">
                        <mat-checkbox
                            *ngFor="let x of Days"
                            [value]="x.value"
                            class="example-margin mr-2 checkbox-wrap"
                            [checked]="x.checked"
                            [disabled]="radio_btn_monthly != 'a'"
                            (change)="MonthDaycheck($event, x)"
                            >{{ x.name }}</mat-checkbox
                        >
                    </section>

                    <ng-container *ngIf="!checkControl('MonthDay') && radio_btn_monthly == 'a'">
                        <div>
                            <p class="error-message" *ngIf="!checkControl('MonthDay')">
                                {{ 'IDMS.REPORTS.PLEASE_SELECT_ATLEAST_ONE_CHECKBOX' | transloco }}
                            </p>
                        </div>
                    </ng-container>
                    <mat-radio-button value="b" class="example-radio-button radio-wrapper"
                        >{{ 'IDMS.REPORTS.ON_CALENDAR_DAYS' | transloco }}
                        <input type="text" class="day_number" style="width: 120px" formControlName="month_number" [disabled]="radio_btn_monthly != 'b'" />
                        <ng-container *ngIf="scheduleForm.get('month_number')?.hasError('invalidNumbers')">
                            <div>
                                <p class="error-message" *ngIf="scheduleForm.get('month_number')?.hasError('invalidNumbers')">
                                    {{ 'IDMS.REPORTS.PLEASE_ENTER_VALID_NUMBERS_BETWEEN_1_AND_31_USE_COMMA_FOR_MORE_THAN_ONE_NUMBERS' | transloco }}
                                </p>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!checkControl('month_number') && radio_btn_monthly == 'b'">
                            <div>
                                <p class="error-message" *ngIf="!checkControl('month_number')">
                                    {{ 'IDMS.REPORTS.PLEASE_INPUT_MONTHS' | transloco }}
                                </p>
                            </div>
                        </ng-container>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
    <div class="row align-items-center mt-3">
        <div class="col-sm-12">
            <mat-label class="font-style label_border schedule_heading">{{ 'IDMS.REPORTS.RANGE_OF_RECURRENCE' | transloco }}</mat-label>
        </div>
    </div>

    <div class="report-range-wrapper">
        <div class="report-range-main">
            <div class="label-wrap">
                <mat-label class="font-style">* {{ 'IDMS.REPORTS.START' | transloco }}</mat-label>
            </div>

            <div class="custom-form-wrapper">
                <dx-date-box
                    class="dx-date-custom-wrapper"
                    type="date"
                    formControlName="start_date"
                    displayFormat="dd-MMM-yyyy"
                    [inputAttr]="{ 'aria-label': 'Choose Date' }"
                    (dateChange)="detectValueChanges($event)"
                    [min]="minDate"
                    [max]="maxDate"
                    (onOpened)="onDateBoxOpened($event)"
                    blockDateTyping
                >
                    <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                </dx-date-box>
                <ng-container *ngIf="start_date?.errors">
                    <div class="error-message" *ngIf="start_date?.errors">{{ 'IDMS.REPORTS.PLEASE_INPUT_START_DATE' | transloco }}</div>
                </ng-container>
            </div>
        </div>

        <div class="time-wrapper">
            <mat-checkbox class="example-margin me-2 checkbox-wrap" formControlName="IsStartTime" style="position: relative; top: 2px">{{
                'IDMS.REPORTS.START_TIME' | transloco
            }}</mat-checkbox>
            <div style="position: relative; top: -4px">
                <input type="number" placeholder="hh" class="day_number_without-background" min="0" max="23" formControlName="start_hour" />:<input
                    type="number"
                    placeholder="mm"
                    class="day_number_without-background"
                    min="0"
                    max="59"
                    formControlName="start_minute"
                />
            </div>
            <ng-container
                *ngIf="
                    (scheduleForm.get('start_hour')?.hasError('required') || scheduleForm.get('start_minute')?.hasError('required')) &&
                    startTimechecked == true &&
                    !(
                        (scheduleForm.get('start_hour')?.hasError('min') ||
                            scheduleForm.get('start_minute')?.hasError('min') ||
                            scheduleForm.get('start_hour')?.hasError('max') ||
                            scheduleForm.get('start_minute')?.hasError('max')) &&
                        startTimechecked == true
                    )
                "
            >
                <div
                    class="error-message"
                    *ngIf="scheduleForm.get('start_hour')?.hasError('required') || scheduleForm.get('start_minute')?.hasError('required')"
                >
                    {{ 'IDMS.REPORTS.PLEASE_INPUT_HOUR_AND_MINUTES' | transloco }}
                </div>
            </ng-container>
            <ng-container
                *ngIf="
                    (scheduleForm.get('start_hour')?.hasError('min') ||
                        scheduleForm.get('start_minute')?.hasError('min') ||
                        scheduleForm.get('start_hour')?.hasError('max') ||
                        scheduleForm.get('start_minute')?.hasError('max')) &&
                    startTimechecked == true
                "
            >
                <div>
                    <p
                        class="error-message hourError"
                        *ngIf="
                            scheduleForm.get('start_hour')?.hasError('min') ||
                            scheduleForm.get('start_minute')?.hasError('min') ||
                            scheduleForm.get('start_hour')?.hasError('max') ||
                            scheduleForm.get('start_minute')?.hasError('max')
                        "
                    >
                        {{ 'IDMS.REPORTS.HOURS_MUST_BE_WITHIN_0_TO_23_AND_MINUTES_MUST_BE_WITHIN_0_AND_59' | transloco }}
                    </p>
                </div>
            </ng-container>
        </div>

        <div class="time-wrapper">
            <div class="">
                <mat-checkbox class="example-margin me-2 checkbox-wrap" (change)="endTimecheck($event)" formControlName="IsEndTime"
                    >{{ 'IDMS.REPORTS.END_BY' | transloco }}
                </mat-checkbox>
            </div>
            <div class="">
                <div class="custom-form-wrapper">
                    <dx-date-box
                        class="dx-date-custom-wrapper"
                        formControlName="end_date"
                        displayFormat="dd-MMM-yyyy"
                        [inputAttr]="{ 'aria-label': 'Choose Date' }"
                        (dateChange)="detectValueChanges($event)"
                        [min]="minDate"
                        [max]="maxDate"
                        (onOpened)="onDateBoxOpened($event)"
                        blockDateTyping
                    >
                    </dx-date-box>
                    <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                    <ng-container *ngIf="!checkControl('end_date') && endTimechecked == true">
                        <div class="error-message" *ngIf="!checkControl('end_date')">
                            {{ 'IDMS.REPORTS.PLEASE_INPUT_END_DATE' | transloco }}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <mat-label class="font-style label_border schedule_heading">{{ 'IDMS.REPORTS.SEND_REPORT' | transloco }}</mat-label>
        </div>
    </div>

    <div class="control-wrapper">
        <div class="row">
            <div class="col-md-2">
                <div class="label-wrap">
                    <mat-label class="font-style">* {{ 'IDMS.REPORTS.TO' | transloco }}:</mat-label>
                </div>
            </div>
            <div class="col-md-10">
                <input type="text" class="input-form-class" matInput name="To" placeholder="{{ 'IDMS.REPORTS.TO' | transloco }}" formControlName="to_address" />

                <ng-container *ngIf="scheduleForm.get('to_address')?.hasError('invalidEmails') && checkControl('to_address')">
                    <div>
                        <p class="error-message" *ngIf="scheduleForm.get('to_address')?.hasError('invalidEmails') && checkControl('to_address')">
                            {{ 'IDMS.REPORTS.PLEASE_ENTER_VALID_EMAIL_ADDRESS_USE_SEMICOLON_FOR_MORE_THAN_ONE_EMAIL_ADDRESSES' | transloco }}
                        </p>
                    </div>
                </ng-container>
                <ng-container *ngIf="!checkControl('to_address')">
                    <div>
                        <p class="error-message" *ngIf="!checkControl('to_address')">
                            {{ 'IDMS.REPORTS.PLEASE_INPUT_EMAIL_ADDRESSES' | transloco }}
                        </p>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <div class="label-wrap">
                    <mat-label class="font-style">{{ 'IDMS.REPORTS.CC' | transloco }}:</mat-label>
                </div>
            </div>
            <div class="col-md-10">
                <input type="text" class="input-form-class" matInput name="Cc" placeholder="{{ 'IDMS.REPORTS.CC' | transloco }}" formControlName="cc_address" />
                <ng-container *ngIf="cc_address?.errors">
                    <div>
                        <p class="error-message" *ngIf="cc_address?.errors">
                            {{ 'IDMS.REPORTS.PLEASE_ENTER_VALID_EMAIL_ADDRESS_USE_SEMICOLON_FOR_MORE_THAN_ONE_EMAIL_ADDRESSES' | transloco }}
                        </p>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <div class="label-wrap">
                    <mat-label class="font-style">{{ 'IDMS.REPORTS.BCC' | transloco }}:</mat-label>
                </div>
            </div>
            <div class="col-md-10">
                <input
                    type="text"
                    class="input-form-class"
                    matInput
                    name="Bcc"
                    placeholder="{{ 'IDMS.REPORTS.BCC' | transloco }}"
                    formControlName="bcc_address"
                />
                <ng-container *ngIf="bcc_address?.errors">
                    <div>
                        <p class="error-message" *ngIf="bcc_address?.errors">
                            {{ 'IDMS.REPORTS.PLEASE_ENTER_VALID_EMAIL_ADDRESS_USE_SEMICOLON_FOR_MORE_THAN_ONE_EMAIL_ADDRESSES' | transloco }}
                        </p>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <div class="label-wrap">
                    <mat-label class="font-style">{{ 'IDMS.REPORTS.SUBJECT' | transloco }}:</mat-label>
                </div>
            </div>
            <div class="col-md-10">
                <input
                    type="text"
                    class="input-form-class"
                    matInput
                    name="Subject"
                    placeholder="{{ 'IDMS.REPORTS.SUBJECT' | transloco }}"
                    formControlName="Subject"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <div class="label-wrap">
                    <mat-label class="font-style">* {{ 'IDMS.REPORTS.FORMAT' | transloco }}:</mat-label>
                </div>
            </div>
            <div class="col-md-6">
                <mat-select class="input-form-class select-form" formControlName="fileTypeValue" class="input-select" panelClass="dropdown-wrapper">
                    <mat-option class="option-list" *ngFor="let l of fileTypeList" [value]="l.value">{{ l.value }}</mat-option>
                </mat-select>

                <ng-container *ngIf="!checkControl('fileTypeValue')">
                    <div>
                        <p class="error-message" *ngIf="!checkControl('fileTypeValue')">
                            {{ 'IDMS.REPORTS.PLEASE_SELECT_FORMAT' | transloco }}
                        </p>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div
        class="row"
        *ngIf="
            reportName == 'Work Flow Completion' || reportName == 'View Hierarchy' || reportName == 'Work Flow Template' || reportName == 'Activity Progress'
        "
    >
        <div class="col-sm-12">
            <mat-label class="font-style label_border schedule_heading">{{ 'IDMS.REPORTS.PARAMETERS' | transloco }}</mat-label>
        </div>
    </div>

    <div class="row"></div>
    <div class="col-sm-12">
        <div class="custom-main-wrapper" [formGroup]="scheduleForm">
            <div class="row">
                <div class="col-md-6" *ngIf="reportName == 'Work Flow Completion'">
                    <div class="custom-form-wrapper">
                        <div class="labelWrap">* {{ 'IDMS.REPORTS.ACTIVITY_PACK_TYPE' | transloco }} :</div>
                        <div>
                            <mat-select
                                #activityPackTypeId
                                formControlName="activityPackTypeId"
                                autocomplete="off"
                                (keydown)="$event.stopPropagation()"
                                multiple
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                [(value)]="selectedOptions"
                            >
                                <!-- [(value)]="selectedOptions" -->

                                <input
                                    placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                    matInput
                                    (keyup)="searchResult($event, 'activityPackTypeId')"
                                    class="report-search"
                                />

                                <div class="select-wrapper">
                                    <mat-checkbox class="checkbox-wrap" formControlName="selectAll" (click)="$event.stopPropagation()">{{
                                        'IDMS.REPORTS.SELECT_ALL' | transloco
                                    }}</mat-checkbox>
                                </div>
                                <mat-option
                                    class="option-list multi-option-list"
                                    [value]="item.activityPackTypeId"
                                    *ngFor="let item of activityPackTypes"
                                    (click)="$event.stopPropagation()"
                                    >{{ item.name }}</mat-option
                                >
                            </mat-select>
                            <ng-container *ngIf="!checkControl('activityPackTypeId')">
                                <p class="error-message" *ngIf="!checkControl('activityPackTypeId')">
                                    {{ 'IDMS.REPORTS.PLEASE_SELECT_ACTIVITY_PACK_TYPE' | transloco }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="reportName == 'View Hierarchy'">
                    <div class="custom-form-wrapper">
                        <div class="labelWrap">* {{ 'IDMS.REPORTS.VIEWS' | transloco }} :</div>
                        <div>
                            <mat-select formControlName="viewId" (keydown)="$event.stopPropagation()" class="dropdown-wrapper" panelClass="dropdown-wrapper">
                                <input
                                    placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                    class="report-search"
                                    (keyup)="searchResult($event, 'viewId')"
                                    style="width: 100%; border: none; outline: none"
                                />

                                <mat-option class="option-list" [value]="item.viewId" *ngFor="let item of Views">{{ item.name }}</mat-option>
                                <ng-container *ngIf="!checkControl('viewId')">
                                    <p class="error-message" *ngIf="!checkControl('viewId')">{{ 'IDMS.REPORTS.PLEASE_SELECT_VIEW' | transloco }}</p>
                                </ng-container>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3 mt-3" *ngIf="reportName == 'Work Flow Template'">
                    <div class="custom-form-wrapper">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.FROM' | transloco }}:</div>
                        <div>
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                formControlName="from_date"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                (dateChange)="detectValueChanges($event)"
                                [disabled]="isEditEnabled === false"
                                [min]="minDate"
                                [max]="maxDate"
                                (onOpened)="onDateBoxOpened($event)"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3 mt-3" *ngIf="reportName == 'Work Flow Template'">
                    <div class="custom-form-wrapper">
                        <div class="labelWrap">* {{ 'IDMS.REPORTS.ACTIVITY_PACK_TYPE' | transloco }} :</div>
                        <div>
                            <mat-select
                                #_activityPackTypeId
                                formControlName="_activityPackTypeId"
                                (keydown)="$event.stopPropagation()"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                [disabled]="!activityPackTypes || activityPackTypes?.length == 0"
                            >
                                <input
                                    class="report-search"
                                    placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                    (keyup)="searchResult($event, '_activityPackTypeId')"
                                />

                                <mat-option class="option-list" [value]="item.activityPackTypeId" *ngFor="let item of activityPackTypes">{{
                                    item.name
                                }}</mat-option>
                            </mat-select>
                            <ng-container *ngIf="!checkControl('_activityPackTypeId')">
                                <p class="error-message" *ngIf="!checkControl('_activityPackTypeId')">
                                    {{ 'IDMS.REPORTS.PLEASE_SELECT_ACTIVITY_PACK_TYPE' | transloco }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3 mt-3" *ngIf="reportName == 'Work Flow Template' && viewActivityPackStatus()">
                    <div class="custom-form-wrapper">
                        <div class="labelWrap">* {{ 'IDMS.REPORTS.ACTIVITY_PACK_STATUS' | transloco }}:</div>
                        <div>
                            <!-- *ngIf="activityPackStatus?.length > 0" -->
                            <mat-select
                                #activityPackTypeStatusId
                                formControlName="activityPackTypeStatusId"
                                autocomplete="off"
                                (keydown)="$event.stopPropagation()"
                                [(value)]="activityPackTypeStatusSelected"
                                multiple
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                [disabled]="!activityPackStatus || activityPackStatus?.length == 0"
                            >
                                <input
                                    placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                    class="report-search"
                                    (click)="$event.stopPropagation()"
                                    (keyup)="searchResult($event, 'activityPackTypeStatusId')"
                                />

                                <div class="select-wrapper">
                                    <mat-checkbox class="checkbox-wrap" formControlName="activityPackTypeStatusselectAll" (click)="$event.stopPropagation()">{{
                                        'IDMS.REPORTS.SELECT_ALL' | transloco
                                    }}</mat-checkbox>
                                </div>
                                <mat-option
                                    class="option-list multi-option-list"
                                    [value]="item.activityPackTypeStatusId"
                                    *ngFor="let item of activityPackStatus"
                                    (click)="$event.stopPropagation()"
                                    [value]="item"
                                    >{{ item.name }}</mat-option
                                >
                            </mat-select>
                            <ng-container *ngIf="!checkControl('activityPackTypeStatusId')">
                                <p class="error-message" *ngIf="!checkControl('activityPackTypeStatusId')">
                                    {{ 'IDMS.REPORTS.PLEASE_SELECT_ACTIVITY_PACK_TYPE_STATUS' | transloco }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3 mt-3" *ngIf="reportName == 'Work Flow Template' && viewActivityPack()">
                    <div class="custom-form-wrapper">
                        <div class="labelWrap">* {{ 'IDMS.REPORTS.ACTIVITY_PACK' | transloco }}:</div>
                        <div>
                            <!-- *ngIf="activityPacks?.length > 0" -->

                            <mat-select
                                #activityPackId
                                formControlName="activityPackId"
                                autocomplete="off"
                                (keydown)="$event.stopPropagation()"
                                [(value)]="activityPackSelected"
                                multiple
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                            >
                                <input
                                    placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                    class="report-search"
                                    (keyup)="searchResult($event, 'activityPackId')"
                                />

                                <div class="select-wrapper">
                                    <mat-checkbox class="checkbox-wrap" formControlName="activityPackIdselectAll" (click)="$event.stopPropagation()">{{
                                        'IDMS.REPORTS.SELECT_ALL' | transloco
                                    }}</mat-checkbox>
                                </div>
                                <mat-option
                                    class="option-list multi-option-list"
                                    [value]="item.activityPackId"
                                    *ngFor="let item of activityPacks"
                                    (click)="$event.stopPropagation()"
                                    [value]="item.activityPackId"
                                    >{{ item.namePrimary }}</mat-option
                                >
                            </mat-select>
                            <ng-container *ngIf="!checkControl('activityPackId')">
                                <p class="error-message" *ngIf="!checkControl('activityPackId')">
                                    {{ 'IDMS.REPORTS.PLEASE_SELECT_ACTIVITY_PACK' | transloco }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3 mt-3" *ngIf="reportName == 'Activity Progress'">
                    <div class="custom-form-wrapper">
                        <div class="labelWrap">* {{ 'IDMS.REPORTS.PROJECT_TYPE' | transloco }} :</div>
                        <div>
                            <mat-select
                                [disabled]="!projectTypes || projectTypes?.length == 0"
                                *ngIf="projectTypes?.length > 0"
                                formControlName="projectTypeId"
                                (keydown)="$event.stopPropagation()"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                            >
                                <input
                                    class="report-search"
                                    placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                    (keyup)="searchResult($event, 'projectTypeId')"
                                    style="width: 100%; border: none; outline: none"
                                />

                                <mat-option class="option-list" [value]="item.projectTypeId" *ngFor="let item of projectTypes">{{ item.name }}</mat-option>
                            </mat-select>
                            <ng-container *ngIf="!checkControl('projectTypeId')">
                                <p class="error-message" *ngIf="!checkControl('projectTypeId')">
                                    {{ 'IDMS.REPORTS.PLEASE_SELECT_PROJECT_TYPE' | transloco }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3 mt-3" *ngIf="reportName == 'Activity Progress'">
                    <div class="custom-form-wrapper">
                        <div class="labelWrap">* {{ 'IDMS.REPORTS.PROJECT' | transloco }} :</div>
                        <div>
                            <mat-select
                                formControlName="projectId"
                                (keydown)="$event.stopPropagation()"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                [disabled]="!projects || projects?.length == 0"
                            >
                                <input
                                    placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                    class="report-search"
                                    (keyup)="searchResult($event, 'projectId')"
                                />

                                <mat-option class="option-list" [value]="item.projectId" *ngFor="let item of projects">{{ item.namePrimary }}</mat-option>
                            </mat-select>
                            <ng-container *ngIf="!checkControl('projectId')">
                                <p class="error-message" *ngIf="!checkControl('projectId')">{{ 'IDMS.REPORTS.PLEASE_SELECT_PROJECT' | transloco }}</p>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- </div> -->
<div class="modal-footer">
    <button type="button" *ngIf="subscriptionData" (click)="removeSubscription()" class="btn primary-ebtn">
        {{ 'IDMS.REPORTS.REMOVE_SUBSCRIPTION' | transloco }}
    </button>
    <button type="button" class="btn secondary-ebtn" (click)="closeClick()">{{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}</button>
    <div class="btn-container">
        <button type="button" [disabled]="!(scheduleForm.valid && scheduleForm.dirty)" (click)="submit(1)" class="btn-save btn primary-ebtn">
            {{ btnTitle }}
        </button>
        <div class="dropdown-content" *ngIf="scheduleForm.valid && scheduleForm.dirty">
            <a href="javascript:void(0)" class="btn primary-ebtn" (click)="submit(2)">{{ btnTitle1 }}</a>
        </div>
    </div>
</div>
